module.exports = __webpack_public_path__ + "static/media/26UNRWA16.f50619c8.jpg";